exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.btn.btn-arrow.btn-primary[data-v-5869bb15]{min-width:115px}.warning-message[data-v-5869bb15]{margin-top:15px}", ""]);

// exports
